import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_GDPR_EXPORT_STATUS_QUERY_KEY } from "../../../constants/queryKeys";

export const useGdprExportStatus = (jobId) => {
  return useQuery({
    queryKey: [SUPPORT_GDPR_EXPORT_STATUS_QUERY_KEY, jobId],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/support/gdpr-export/${jobId}`,
        method: "GET"
      });
    },
    enabled: !!jobId,
    refetchInterval: (data) => {
      const state = data?.state;
      return state === "completed" || state === "failed" ? false : 3000;
    }
  });
};
